export default() => {
  const supportMouse = 'onmouseup' in document;
  const CLICK_OR_TOUCH_EVENT = supportMouse ? 'click' : 'touchend';

  // アコーディオンボタンクリックイベント
  const toggleAccordion = e => {
    const btnEl = e.currentTarget;
    if (btnEl.classList.contains('fadeout')) return;

    btnEl.nextElementSibling.classList.toggle('open');
    btnEl.classList.toggle('open');
  };

  window.addEventListener('load', () => {
    const accordionBtnList = document.getElementsByClassName('btn-accordion');
    for (let i = 0; i < accordionBtnList.length; i++) {
      accordionBtnList[i].addEventListener(CLICK_OR_TOUCH_EVENT, toggleAccordion);
    }
  });
}